// extracted by mini-css-extract-plugin
export default {"headerWrapper":"_f1ced6ce","small":"_18637c9d","medium":"_d8893e1f","large":"_a5d6447f","xLarge":"_a599a327","xxLarge":"_5a5b639f"};